export function getReactionCount(
  localReactions: Map<number, Map<string, number>>,
  commentId: number,
  reactionType: string,
  originalCount: number = 0,
): number {
  const localCommentReactions = localReactions.get(commentId);
  if (!localCommentReactions) {
    return originalCount;
  }
  const localCount = localCommentReactions.get(reactionType);
  return localCount !== undefined ? localCount : originalCount;
}

export function getUserReaction(
  localUserReactions: Map<number, string | null>,
  commentId: number,
  originalUserReaction: string | null,
): string | null {
  if (localUserReactions.has(commentId)) {
    return localUserReactions.get(commentId) || null;
  }
  return originalUserReaction;
}

export function applyOptimisticReaction(
  prev: Map<number, Map<string, number>>,
  commentId: number,
  reactionType: string,
  currentUserReaction: string | null,
  originalReactionsCount: Record<string, number> | null | undefined,
  isRemovingReaction: boolean,
): Map<number, Map<string, number>> {
  const newMap = new Map(prev);

  let commentReactions: Map<string, number>;
  if (newMap.has(commentId)) {
    commentReactions = new Map(newMap.get(commentId));
  } else {
    commentReactions = new Map();
    if (originalReactionsCount) {
      Object.entries(originalReactionsCount).forEach(([type, count]) => {
        if (count && typeof count === 'number' && count > 0) {
          commentReactions.set(type, count);
        }
      });
    }
  }

  if (isRemovingReaction) {
    const currentCount = commentReactions.get(reactionType) || 0;
    if (currentCount > 0) {
      commentReactions.set(reactionType, currentCount - 1);
    }
  } else {
    const currentCount = commentReactions.get(reactionType) || 0;
    commentReactions.set(reactionType, currentCount + 1);

    if (currentUserReaction) {
      const oldCount = commentReactions.get(currentUserReaction) || 0;
      if (oldCount > 0) {
        commentReactions.set(currentUserReaction, oldCount - 1);
      }
    }
  }

  newMap.set(commentId, commentReactions);
  return newMap;
}
